import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/styles';
import { Button as MaterialButton } from '@material-ui/core';

import {
  ButtonVariantContained, ButtonVariantText, ButtonVariantOutlined
} from "../buttons/constants.js";

const styles = theme => ({
  root: {
  },
});

const ButtonTypeButton = "button";
const ButtonTypeSubmit = "submit";

/**
 * Simple button. Use it for create form submit or action with click handler
 * @name Button
 * @param {object} props React component properties
 * @param {string} [props.type = "button"] Type of button. Available values: "button", "submit". 
 * @param {string} [props.className] CSS-class of button
 * @param {string} [props.labelClass] Specific CSS-class for button label
 * @param {string} [props.variant = "contained"] View variant for button stylization. Available values:
 *  - {@link https://material-ui.com/components/buttons/#contained-buttons|"contained"}
 *  - {@link https://material-ui.com/components/buttons/#outlined-buttons|"outlined"}
 *  - {@link https://material-ui.com/components/buttons/#text-buttons|"text"}
 * 
 * NOTE: for providing variant, please, import necessary variant as constant from file "components/base/buttons/constants.js.jsx"
 * @param {string} [props.component] Component. If the prop passed, in html-layout will draw element with value of property
 * 
 * Source: {@link https://material-ui.com/api/button/}
 * @param {node} [props.startIcon] Icon inside the button
 * @param {boolean} [props.ariaHaspopup = false] Use it, if you create button with dropdown menu. 
 * Source: {@link https://material-ui.com/components/menus/#simple-menu}
 * @param {boolean} [props.ariaControls] Use it, if you create button with dropdown menu.
 * Source: {@link https://material-ui.com/components/menus/#simple-menu}
 * @param {func} [props.onClick] Click listener
 * @param {boolean} [props.disabled = false] Disable/enable button
 * @example
 * return (
 *   <Button className={ "awesome-class" } 
 *           onClick = { this.onClickHandler } >
 *    { "Click me!" }
 *   </Button>
 * )
*/
class Button extends React.Component {

  constructor(props) {
    super(props);
    
    this.state = {
      
    }
  }

  static getDerivedStateFromProps(props, state) {
    return {
      disabled: props.disabled
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    return this.state.disabled !== nextState.disabled ||
           this.props.className !== nextProps.className;
  }

  render() {
    const {
      classes, className, labelClass, 
      variant, 
      component, startIcon,
      ariaControls, ariaHaspopup
    } = this.props;

    const { type, onClick, children } = this.props;

    const { disabled } = this.state;

    let additionalClasses = {};
    if(labelClass) {
      additionalClasses.label = labelClass;
    }

    return <MaterialButton className = { clsx(classes.root, className) } 
                           classes = { additionalClasses }
                           disabled = { disabled }
                           variant = { variant }
                           component = { component }
                           type = { type }
                           startIcon = { startIcon }
                           onClick = { onClick }
                           aria-controls = { ariaControls }
                           aria-haspopup = { ariaHaspopup } >
      { children }
    </MaterialButton>
  }
}

Button.propTypes = {
 className: PropTypes.string,
 labelClass: PropTypes.string,
 type: PropTypes.oneOf([ButtonTypeButton, ButtonTypeSubmit]),
 variant: PropTypes.oneOf([
   ButtonVariantContained, ButtonVariantText, ButtonVariantOutlined
 ]),
 component: PropTypes.string,
 startIcon: PropTypes.node,
 ariaHaspopup: PropTypes.bool,
 ariaControls: PropTypes.string,
 onClick: PropTypes.func,
 disabled: PropTypes.bool
};

Button.defaultProps = {
  type: ButtonTypeButton,
  variant: ButtonVariantContained,
  ariaHaspopup: false,
  disabled: false
}

const styledButton = withStyles(styles)(Button);
export default styledButton;
